import { z } from "zod";

import { api } from "@/redux/api";

/**
 * Whether a lead is already tracked, for the "Add to Tracker" footer of Compose and Review to send
 * (PREC-4497). The pages' leads come from `GET list/all-prospects`, which carries no tracker rows,
 * so the footer asks for this one fact per lead instead of reading `prospect.trackerPersons`.
 *
 * Injected from its own module rather than from `list.api.ts`, which is past the 500-line ceiling.
 * It provides the lead's `ListPerson` tag, so `bulkAddToTracker` (which invalidates `ListPerson`)
 * refetches it and the button turns into "Added to Tracker" after an add.
 */
export const trackerMembershipSchema = z.object({
	listPersonId: z.number(),
	tracked: z.boolean(),
});

export type TrackerMembership = z.infer<typeof trackerMembershipSchema>;

export const listTrackerMembershipApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getListPersonTrackerMembership: builder.query<TrackerMembership, number>({
			query: (listPersonId) => ({
				url: `list_person/${listPersonId}/tracker-membership`,
				method: "GET",
				responseSchema: trackerMembershipSchema,
			}),
			providesTags: (result, error, listPersonId) => [{ type: "ListPerson", id: listPersonId }],
		}),
	}),
});

export const { useGetListPersonTrackerMembershipQuery } = listTrackerMembershipApi;
